import { SidebarSearchContext } from '@/contexts/sidebar-search.context'
import { useContext } from 'react'

function useSidebarSearch() {
  const context = useContext(SidebarSearchContext)
  if (context === undefined) throw new Error('useSidebarSearch must be used within a SidebarSearchProvider')
  return context
}

export default useSidebarSearch
